'use client';

import { LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features: string[];
  techStack: string[];
  delay?: number;
}

const ServiceCard = ({
  icon: Icon,
  title,
  description,
  features,
  techStack,
  delay = 0,
}: ServiceCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="border-t border-border py-8"
    >
      <div className="mb-4 flex items-center gap-3">
        <Icon className="h-5 w-5 text-primary" strokeWidth={1.75} />
        <h3 className="font-display text-xl font-semibold text-foreground sm:text-2xl">{title}</h3>
      </div>
      <p className="mb-6 max-w-xl text-sm leading-relaxed text-text-secondary sm:text-base">
        {description}
      </p>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ul className="space-y-2">
          {features.map((feature) => (
            <li key={feature} className="flex items-start gap-2 text-sm text-foreground">
              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-primary" />
              {feature}
            </li>
          ))}
        </ul>
        <p className="text-sm text-text-secondary">
          <span className="mb-2 block font-sans text-xs font-semibold uppercase tracking-[0.15em]">
            Stack
          </span>
          {techStack.join(' · ')}
        </p>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
